import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";

import DropDown from "../../Common/Forms/DropDown";
import DropDownListMultiCheckboxOptions from "../../Common/Forms/DropDownListMultiCheckboxOptions";
import FormButtonsForCloseAndSubmit from "../../Common/Forms/FormButtonsForCloseAndSubmit";

const aarItems = [
  {
    id: new Date().getFullYear().toString(),
    navn: new Date().getFullYear().toString(),
  },
  {
    id: (new Date().getFullYear() - 1).toString(),
    navn: (new Date().getFullYear() - 1).toString(),
  },
  {
    id: (new Date().getFullYear() - 2).toString(),
    navn: (new Date().getFullYear() - 2).toString(),
  },
  {
    id: (new Date().getFullYear() - 3).toString(),
    navn: (new Date().getFullYear() - 3).toString(),
  },
  {
    id: (new Date().getFullYear() - 4).toString(),
    navn: (new Date().getFullYear() - 4).toString(),
  },
];

const handleSubmit = (
  event,
  aar,
  selectedIleggelsestyper,
  handleSubmit,
  setShowSokSpinner,
) => {
  setShowSokSpinner(true);
  handleSubmit(event, aar, selectedIleggelsestyper)
    .then(() => setShowSokSpinner(false))
    .catch(() => setShowSokSpinner(false));
};

const AArsrapportFilterForm = (props) => {
  const { getIleggelsestyper } = props;
  const [showSokSpinner, setShowSokSpinner] = useState(false);

  useEffect(() => {
    getIleggelsestyper();
  }, [getIleggelsestyper]);

  return (
    <form
      onSubmit={(event) =>
        handleSubmit(
          event,
          props.aarsrapportFilterForm.aar,
          props.aarsrapportFilterForm.selectedIleggelsestyper,
          props.handleSubmit,
          setShowSokSpinner,
        )
      }
      className="filter-container"
    >
      <div className="searchHistorikkOverskrift">
        Årsrapport basert på ileggelsestype
      </div>
      <div className="filter-flexbox-container klager-filter-flexbox">
        <div>
          <DropDown
            label="År"
            name="aar"
            items={aarItems}
            selected={props.aarsrapportFilterForm.aar}
            title="Velg"
            onChange={props.handleChangeAAr}
            validationError={props.aarsrapportFilterForm.aarValidationErrorText}
          />
        </div>
        <DropDownListMultiCheckboxOptions
          label="Ileggelsestype"
          name="selectedIleggelsestyper"
          items={props.ileggelsestyper
            .filter((it) => it.navn !== "Avgift")
            .map((filteredIleggelsestype) => ({
              id: filteredIleggelsestype.id,
              navn: filteredIleggelsestype.navn,
            }))}
          selected={props.aarsrapportFilterForm.selectedIleggelsestyper}
          title={
            props.aarsrapportFilterForm.selectedIleggelsestyper.length > 0
              ? `${props.aarsrapportFilterForm.selectedIleggelsestyper.length} valg`
              : "Velg"
          }
          onChange={props.handleChangeIleggelsestype}
          validationError={
            props.aarsrapportFilterForm.ileggelsestyperValidationErrorText
          }
        />
      </div>
      <Row>
        <Col sm={12}>{props.error}</Col>
      </Row>
      <Row>
        <Col sm={12}>
          <FormButtonsForCloseAndSubmit
            submitText="Søk"
            onClose={props.handleChangeToInitState}
            showSubmitSpinner={showSokSpinner}
          />
        </Col>
      </Row>
    </form>
  );
};

export default AArsrapportFilterForm;
